<template>
  <form @submit.prevent.stop="submit">
    <div v-if="alerts.length > 0" class="form-group">
      <alert-box v-for="alert in alerts" :key="alert" type="danger">
        <span v-html="alert" />
      </alert-box>
    </div>
    <div class="form-group">
      <label for="login-email">Email</label>
      <input
        id="login-email"
        v-model.lazy.trim="email"
        class="form-control"
        placeholder="Your Email Address"
        type="email"
        required
        autofocus
        autocomplete="email"
      />
    </div>
    <div class="form-group">
      <label for="login-password">Password</label>
      <input
        id="login-password"
        v-model.lazy="password"
        class="form-control"
        placeholder="Your Password"
        type="password"
        required
        autocomplete="current-password"
      />
    </div>
    <div class="row form-group">
      <div class="col-md-6">
        <div class="checkbox">
          <label>
            <input v-model="remember" type="checkbox" value="1" />
            Remember me
          </label>
        </div>
      </div>
      <div class="col-md-6 text-right">
        <submit-button
          loading-label="Please wait..."
          class="btn-primary"
          :loading="loading"
        >
          Log in
        </submit-button>
      </div>
    </div>
  </form>
</template>

<script>
  import axios from "axios"
  import Cookies from "js-cookie"
  import SubmitButton from "./submit-button"
  import AlertBox from "./alert-box"

  export default {
    components: {
      SubmitButton,
      AlertBox,
    },
    props: {
      url: {
        type: String,
        required: true,
      },
      host: {
        type: String,
        required: true,
      },
      redirectUrl: {
        type: String,
        default: "",
      },
      cookieExpirationDays: {
        type: Number,
        default: 7,
      },
      successMessage: {
        type: String,
        default: "Signed in successfully.",
      },
    },
    data() {
      return {
        remember: false,
        password: null,
        email: null,
        loading: false,
        alerts: [],
      }
    },
    methods: {
      submit() {
        this.alerts = []
        this.loading = true
        axios
          .post(this.url, {
            spree_user: {
              email: this.email,
              password: this.password,
              remember_me: this.remember ? "1" : "0",
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.flash(this.successMessage)
              this.redirectOrBack()
            } else {
              this.loading = false
              this.alerts = response.data.errors
            }
          })
          .catch((error) => {
            if (error?.response?.data?.errors) {
              this.alerts = error.response.data.errors
            } else {
              this.alerts.push(error.message || error)
            }
            this.loading = false
          })
      },
      redirectOrBack() {
        if (this.redirectUrl !== "") {
          this.redirect(this.redirectUrl)
        } else if (document.referrer.indexOf(this.host) >= 0) {
          window.history.back()
        } else {
          this.redirect("/")
        }
      },
      flash(message) {
        Cookies.set("cs_flash_message", message)
      },
      redirect(path) {
        window.location.assign(path)
      },
    },
  }
</script>
